"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Item = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["children", "vertical"],
  _excluded2 = ["children", "className"];
var _templateObject;
var MenuStyles = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  gap: 10px;\n  padding: 0px clamp(10px, 15vw, 100px) 20px;\n"])), function (props) {
  return props.vertical ? "column" : "row";
});
var Menu = function Menu(_ref) {
  var children = _ref.children,
    vertical = _ref.vertical,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(MenuStyles, Object.assign({
    vertical: vertical
  }, props), children);
};
var Item = function Item(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return _react.default.createElement("div", Object.assign({
    className: "bfMenuItem " + (className || "")
  }, props), children);
};
exports.Item = Item;
Menu.Item = Item;
var _default = Menu;
exports.default = _default;